import React, { Component } from "react";

import ReactUUID from "react-uuid";

export default class UBXButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: "",
        };
    }

    async componentDidMount() {
        const { id = ReactUUID() } = this.props;

        await this.setState({ id });
    }

    onClick(e) {
        const { onClick = false, submit = false } = this.props;

        if (onClick) {
            if (!submit) {
                e.preventDefault();
            }

            onClick(e);
            return false;
        }

        return true;
    }

    render() {
        const {
            className: customClassNames = false,
            children = "",
            type = false,
            block = false,
            disabled = false,
            selected = false,
            submit = false,
            size = "medium",
            icon = false,
            iconLeft = false,
            iconRight = false,
            busy = false,
            busyText = false,
            ...otherProps
        } = this.props;
        const { id } = this.state;

        const customAttrs = { id, ...otherProps };

        if (disabled || busy) {
            customAttrs["disabled"] = true;
        }

        if (icon || iconLeft || iconRight) {
            if (icon) {
                customAttrs["icon-left"] = busy ? "busy" : icon;
            } else if (iconLeft) {
                customAttrs["icon-left"] = busy ? "busy" : iconLeft;
            }

            if (iconRight) {
                customAttrs["icon-right"] = busy ? "busy" : iconRight;
            }
        } else {
            if (busy) {
                customAttrs["icon-left"] = "busy";
            }
        }

        if (submit) {
            customAttrs["type"] = "submit";
            if (submit !== true) {
                customAttrs["form"] = submit;
            }
        } else {
            customAttrs["type"] = "button";
        }

        const classNames = ["ubx-commons", "button"];
        if (type) {
            classNames.push(type);
        }
        if (block) {
            classNames.push(block === true ? "block" : `block-${block}`);
        }
        if (selected) {
            classNames.push("selected");
        }
        if (customClassNames) {
            if (Array.isArray(customClassNames)) {
                customClassNames.forEach((customClassName) => classNames.push(customClassName));
            } else if (typeof customClassNames === "string") {
                classNames.push(customClassNames);
            }
        }

        if (size) {
            let sizeClass = false;
            switch (size) {
                case "xsmall":
                    sizeClass = "xs";
                    break;
                case "small":
                    sizeClass = "sm";
                    break;
                case "large":
                    sizeClass = "lg";
                    break;
                case "xlarge":
                    sizeClass = "xl";
                    break;
                default:
                    sizeClass = "";
                    break;
            }
            if (sizeClass) {
                classNames.push(sizeClass);
            }
        }

        return (
            <button className={classNames.join(" ")} {...customAttrs} onClick={(e) => this.onClick(e)}>
                {busy && busyText ? busyText : children}
            </button>
        );
    }
}
